const filePrefix = process.env.BASE_FILE_URL

export default filePrefix



// WEBPACK FOOTER //
// ./src/utils/setFilePrefix.js